export const TOOLTIP_MESSAGES = {
	potisionsDisabledDeleteMessage: 'Position cannot be deleted due to assigned employees',
	underConstruction: 'Under Construction!',
	documentBeingProcessed: 'Document is being processed.',
	unsavedChanges: 'Selection is disabled until changes are saved',
	creditsAppliedMessage: 'Selection is disabled because credits have been applied.',
	selectAssignmentDisabledMessage: 'Cannot select an inactive assignment',
};
